export default __webpack_public_path__ + "static/recorlev-logics-dosing-guidelines-steps-d68620b43224c47703d5dc0b5971aaaf.svg";